import React, { useState } from 'react';

import { InfoLabel } from '../../../../common/components';
import { Col, Row } from 'react-bootstrap';


import Icon from '../../../../common/components/Icon/Icon';

import ReactMarkdown from 'react-markdown';
import './AgreedDeclaration.scss';


export const AgreedDeclaration = ({
  label,
  declaration,
}) => {
  const [show, setShow] = useState(false);

  const toggleContentView = () => {
    setShow(!show);
  };
  if (!declaration) {
    return null;
  }

  const content = declaration.declaration;


  return (
    <div>
      <Row>
        <Col sm={6}>
          <InfoLabel
            label={label}
            value={
              <span className="display-icon" onClick={toggleContentView}>
                <Icon name={show ? 'minus' : 'plus'}/>
              </span>
            }
            labelSize={4}
            wrapperClass={'clear-margin'}
          />
        </Col>
      </Row>
      {show && (
        <>
          <div>
            <ReactMarkdown className={'renewal-declaration--content RichEditor-root'}>
              {content}
            </ReactMarkdown>
          </div>
          <InfoLabel
            label={'Declaration Agreed'}
            value={declaration.answer ? 'Yes' : 'No'}
          />

        </>
      )}

    </div>
  );
};

